import * as Yup from 'yup';
import { constant } from 'common/constant';

export const interviewValidationSchema = Yup.object().shape({
  application: Yup.string().required('Application is required'), // ObjectId as string
  candidate: Yup.string().required('Candidate is required'),
  candidateEmail: Yup.string()
    .email('Invalid candidate email')
    .required('Candidate email is required'),
  interviewers: Yup.array()
    .of(Yup.string().required('Each panel ID is required'))
    .min(1, 'At least one interviewer panel is required')
    .required('Interviewers are required'), // Array of ObjectId strings
  round: Yup.string().required('Interview round is required'),
  interviewStatus: Yup.string().required('Interview status is required'),
  interviewerFeedback: Yup.string().nullable(), // Optional
  interviewMode: Yup.string().required('Interview mode is required'),
  interviewDate: Yup.date()
    .required('Interview date is required')
    .typeError('Invalid interview date'),
  // department: Yup.string().required('Department is required'), // ObjectId as string
  startTime: Yup.date()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .typeError('Invalid start time'),
  endTime: Yup.date()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .typeError('Invalid end time')
    .when('startTime', (startTime, schema) =>
      startTime ? schema.min(Yup.ref('startTime'), 'End time must be after start time') : schema
    ),
  commentForInterviewer: Yup.string().nullable(), // Optional
  reason: Yup.string()
  .when("interviewStatus", {
    is: "cancelled",
    then: (schema) =>
      schema
        .required("Reason is required when interview is cancelled")
        .min(10, "Reason must be at least 10 characters long")
        .max(250, "Reason must be less than 250 characters"),
    otherwise: (schema) => schema.nullable(),
  }),
});
